// extracted by mini-css-extract-plugin
export var center = "Image-module--center--95812";
export var overflow = "Image-module--overflow--fe048";